(function(){
  function init(){
    var buttons = document.querySelectorAll('.ugc-video-wall .ugc-wall-item__play');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function(e){
        var wrap = e.currentTarget.closest('.ugc-wall-item__thumb');
        var video = wrap.querySelector('video');
        var src = wrap.getAttribute('data-video-src');
        if (!src || src.indexOf('REPLACE_WITH_REAL_VIDEO_URL') === 0) { return; }
        video.src = src;
        video.setAttribute('controls', 'controls');
        video.load();
        video.play();
        e.currentTarget.style.display = 'none';
      });
    }
    document.querySelectorAll('.ugc-wall-carousel-wrap').forEach(function(wrap){
      var track = wrap.querySelector('.ugc-wall-track');
      var prev = wrap.querySelector('.ugc-wall-arrow--prev');
      var next = wrap.querySelector('.ugc-wall-arrow--next');
      if (prev) prev.addEventListener('click', function(){ track.scrollBy({left: -240, behavior: 'smooth'}); });
      if (next) next.addEventListener('click', function(){ track.scrollBy({left: 240, behavior: 'smooth'}); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
